<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <b-row class="justify-content-md-center">
      <b-col cols="12" md="6">
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Title</label>
              <b-form-input v-model="notification.title" type="text" id="title" placeholder="Title"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <label for="name">Message</label>
              <b-form-textarea
                id="body"
                v-model="notification.body"
                placeholder="Message"
                rows="4"
                max-rows="7"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <span>* Once notification is sent it cannot be retrived</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="py-2 justify-content-md-center">
      <span style="color:red">{{msg}}</span>
    </b-row>
    <b-row class="justify-content-center">
      <div class="px-2">
        <b-button
          variant="outline-primary"
          size="sm"
          @click.prevent="sendNotification"
        >Send Notification</b-button>
      </div>
      <div class="px-2">
        <b-button variant="outline-danger" size="sm" @click.prevent="colseDialog">Cancel</b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      appLoading: false,
      notification: {
        title: null,
        body: null
      },
      msg: null
    };
  },
  methods: {
    colseDialog() {
      this.$emit("close", { status: true, update: false });
    },
    sendNotification() {
      if (!this.notification.body || !this.notification.title) {
        this.msg = "Title & Message are Required";
        return;
      }
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/notification/adminadd",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: this.notification
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.$emit("close", { status: true, update: true });
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.$emit("close", { status: false, update: false });
        });
    }
  }
};
</script>


